import LoginOnBehalf from 'organisms/LoginOnBehalf';
import { useState } from 'react';
import useGlobalToastStore from 'store/globalToastStore';
import { loadResourceOptions } from '@/components/Utilities/people-picker';
import { createImpersonationService } from 'services/impersonation.service';
import useSessionStore from 'store/sessionStore'
import { useRouter } from 'hooks/navigation-router-with-loading';
import { useSession } from 'next-auth/react';
import { debounce } from 'helper/util';
const searchResults = [
    {
        userpic: '/images/Userpic.png',
        name: 'Ram Manohar',
        designation: 'Deputy manager ',
        position: 'Business operations ',
        category: 'Operation transformation',
        Subcategory: 'Gps advice',
        empID: 'EM0102023'
    },
    {
        userpic: '/images/Userpic.png',
        name: 'Ram Manohar',
        designation: 'Deputy manager ',
        position: 'Business operations ',
        category: 'Operation transformation',
        Subcategory: 'Gps advice',
        empID: 'EM0102023'
    }
];

function LoginBehalf({ onClose }) {
    const [resources, setResources] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [, setHasMore] = useState(true);
    const [, setOffset] = useState(0);
    const router = useRouter();
    const { data: session, update } = useSession();

    const { setToastData } = useGlobalToastStore();
    const { setEndSession } = useSessionStore();

    const onLogin = async (data) => {
        const result = await createImpersonationService({ resourceId: data.id, validate: true });
        if(result.status) {
            setEndSession({ show: true, color: 'green' });
            update({
                loginOnBehalf: true,
                resourceId: data.id,
                impersonatingUserId: session.user.id,
            });
            onClose();
            setToastData({ show: true, message: `Successfully logged as ${data.name}` });
            setTimeout(() => {
                window.location.href = ('/');
            }, 400);
        } else {
            setToastData({ show: true, message: result.errorMessage, type: 'error' });
        }
    };

    const onSearch = async (val) => {
        const resources = await loadResourceOptions('', '', '', '', '', '', { loginOnBehalf: true })(val, setOffset, setHasMore, 50);
        setResources(resources.options.map((resource) => ({
            id: resource.id,
            userpic: '',
            name: resource.name,
            designation: resource.designation,
            position: resource.employeeFunction,
            category: resource.serviceArea,
            Subcategory: resource.subServiceArea,
            SubSubcategory: resource.subSubFunctionDesc,
            empID: resource.employeeCode,
            email: resource.email,
        })));
    };

    const debouncedSearch = debounce(onSearch, 500);

    return (
        <LoginOnBehalf
            searchResults={resources}
            onClose={onClose}
            valueChanged={debouncedSearch}
            onLogin={onLogin}
            showAlert={showAlert}
            setShowAlert={setShowAlert}
        />
    );
}

export default LoginBehalf;
